import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { AbleConfigSchema } from '../interfaces/ableConfigSchema';
import { AbleService } from '../services/able.service';

export type { AbleConfigSchema };

const DEFAULT_ABLE_VERSION = 'r32.4.4_v2.13.20';

export const useAbleConfigSchemaQuery = (version: string = DEFAULT_ABLE_VERSION): UseQueryResult<AbleConfigSchema> => {
  return useQuery<AbleConfigSchema>({
    queryKey: ['able-config-schema', version],
    queryFn: () => AbleService.getAbleConfigSchema(version),
    staleTime: Infinity, // Schema doesn't change often
    cacheTime: 1000 * 60 * 60, // Cache for 1 hour
  });
};
